export default "__VITE_ASSET__B75g_CaQ__"